// frontend/src/pages/SearchPage.js



//



// Search results page with सूत उवाच Oracle synthesis panel.



// Flow: search â†’ verse results â†’ user clicks सूत उवाच â†’ synthesis expands above results.







import { useState, useEffect, useCallback } from 'react';



import { useSearchParams } from 'react-router-dom';



import SearchBar from '../components/search/SearchBar';



import VerseCard from '../components/verse/VerseCard';



import { useSearch } from '../hooks/useSearch';



import ApiService from '../services/ApiService';



import styles from './SearchPage.module.css';







// â”€â”€ Inline citation chip renderer â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€



// Converts [VERSE_ID] markers in synthesis text to styled chips



function SynthesisText({ text, citedVerses }) {



  if (!text) return null;



  const verseMap = {};



  (citedVerses || []).forEach(v => { verseMap[v.verse_id] = v; });







  const parts = text.split(/(\[[^\]]+\])/g);



  return (



    <span>



      {parts.map((part, i) => {



        const m = part.match(/^\[([^\]]+)\]$/);



        if (m) {



          const v = verseMap[m[1]];



          const label = v



            ? `${v.source_title || v.source_code} ${v.chapter ? v.chapter + '.' + v.verse_number : ''}`.trim()



            : m[1];



          return <span key={i} className={styles.citationChip} title={v?.iast_text || ''}>{label}</span>;



        }



        return <span key={i}>{part}</span>;



      })}



    </span>



  );



}







// â”€â”€ Synthesis panel â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€



function SutaPanel({ query, onClose }) {



  const [status,   setStatus]   = useState('idle'); // idle | loading | done | error



  const [synthesis, setSynthesis] = useState(null);



  const [lens,     setLens]     = useState('advaita');



  const [depth,    setDepth]    = useState('standard');



  const [expanded, setExpanded] = useState({}); // verse_id â†’ bool







  const lenses = [



    { id: 'advaita',          label: 'Advaita' },



    { id: 'vishishtadvaita',  label: 'ViÅ›iá¹£á¹­ādvaita' },



    { id: 'dvaita',           label: 'Dvaita' },



    { id: 'shaiva',           label: 'Åšaiva' },



  ];







  const invoke = useCallback(async () => {



    if (!query) return;



    setStatus('loading');



    setSynthesis(null);



    try {



      const result = await ApiService.synthesize({ question: query, lens, depth });



      setSynthesis(result);



      setStatus('done');



    } catch (err) {



      setStatus('error');



    }



  }, [query, lens, depth]);







  // Auto-invoke on mount



  useEffect(() => { invoke(); }, [invoke]);







  return (



    <div className={styles.sutaPanel}>







      {/* Header */}



      <div className={styles.sutaHeader}>



        <div className={styles.sutaTitle}>



          <span className={styles.sutaDeva}>सूत उवाच</span>



          <span className={styles.sutaSub}>The Oracle speaks</span>



        </div>



        <button className={styles.sutaClose} onClick={onClose} aria-label="Close Oracle">âœ•</button>



      </div>







      {/* Controls */}



      <div className={styles.sutaControls}>



        <div className={styles.lensRow}>



          <span className={styles.controlLabel}>Lens</span>



          {lenses.map(l => (



            <button



              key={l.id}



              className={`${styles.lensChip} ${lens === l.id ? styles.lensChipOn : ''}`}



              onClick={() => setLens(l.id)}



            >{l.label}</button>



          ))}



        </div>



        <div className={styles.depthRow}>



          <span className={styles.controlLabel}>Depth</span>



          <button className={`${styles.depthChip} ${depth === 'standard' ? styles.depthOn : ''}`} onClick={() => setDepth('standard')}>Standard</button>



          <button className={`${styles.depthChip} ${depth === 'deep' ? styles.depthOn : ''}`} onClick={() => setDepth('deep')}>Deep · Sonnet</button>



          <button className={styles.reinvokeBtn} onClick={invoke} disabled={status === 'loading'}>



            {status === 'loading' ? '⟳' : 'â†º Ask again'}



          </button>



        </div>



      </div>







      {/* Loading */}



      {status === 'loading' && (



        <div className={styles.sutaLoading}>



          <div className={styles.sutaShimmer} />



          <div className={styles.sutaShimmer} style={{ width: '82%' }} />



          <div className={styles.sutaShimmer} style={{ width: '91%' }} />



          <div className={styles.sutaShimmerSm} />



          <p className={styles.sutaLoadingHint}>Sūta is consulting the tradition…</p>



        </div>



      )}







      {/* Error */}



      {status === 'error' && (



        <div className={styles.sutaError}>



          <span>The Oracle is unavailable. Deploy the synthesis engine to Lambda first.</span>



          <button className={styles.retryBtn} onClick={invoke}>Retry</button>



        </div>



      )}







      {/* Synthesis */}



      {status === 'done' && synthesis && (



        <div className={styles.sutaBody}>







          {/* Meta */}



          <div className={styles.sutaMeta}>



            <span>{synthesis.meta?.verses_searched} verses searched</span>



            <span className={styles.metaDot}>·</span>



            <span>{synthesis.meta?.verses_cited} cited</span>



            <span className={styles.metaDot}>·</span>



            <span>{synthesis.meta?.latency_ms}ms</span>



            <span className={styles.metaDot}>·</span>



            <span className={styles.metaModel}>{synthesis.meta?.model?.includes('haiku') ? 'Haiku' : 'Sonnet'}</span>



          </div>







          {/* Synthesis prose */}



          <div className={styles.sutaSynthesis}>



            <SynthesisText text={synthesis.synthesis} citedVerses={synthesis.cited_verses} />



          </div>







          {/* Key terms */}



          {synthesis.key_terms?.length > 0 && (



            <div className={styles.keyTerms}>



              {synthesis.key_terms.map(t => (



                <span key={t} className={styles.keyTerm}>{t}</span>



              ))}



            </div>



          )}







          {/* Dissenting views */}



          {synthesis.dissenting_views?.length > 0 && (



            <div className={styles.dissentBlock}>



              <p className={styles.dissentTitle}>Other Schools</p>



              {synthesis.dissenting_views.map((d, i) => (



                <div key={i} className={styles.dissentItem}>



                  <span className={styles.dissentSchool}>{d.school}</span>



                  <span className={styles.dissentPos}>{d.position}</span>



                </div>



              ))}



            </div>



          )}







          {/* Cited verses â€” expandable */}



          {synthesis.cited_verses?.length > 0 && (



            <div className={styles.citedBlock}>



              <p className={styles.citedTitle}>Sources Consulted · {synthesis.cited_verses.length}</p>



              {synthesis.cited_verses.map(v => (



                <div key={v.verse_id} className={styles.citedCard}>



                  <button



                    className={styles.citedToggle}



                    onClick={() => setExpanded(e => ({ ...e, [v.verse_id]: !e[v.verse_id] }))}



                  >



                    <span className={styles.citedSource}>{v.source_title || v.source_code}</span>



                    {v.chapter && <span className={styles.citedRef}>{v.chapter}.{v.verse_number}</span>}



                    <span className={styles.citedScore}>{Math.round((v.semantic_score || 0) * 100)}%</span>



                    <span className={styles.citedArrow}>{expanded[v.verse_id] ? 'â–²' : 'â–¼'}</span>



                  </button>



                  {expanded[v.verse_id] && (



                    <div className={styles.citedExpanded}>



                      {v.original_text && <p className={styles.citedDeva}>{v.original_text}</p>}



                      {v.iast_text     && <p className={styles.citedIast}>{v.iast_text}</p>}



                      {v.english_translation && <p className={styles.citedTrans}>{v.english_translation}</p>}



                    </div>



                  )}



                </div>



              ))}



            </div>



          )}







        </div>



      )}



    </div>



  );



}







// â”€â”€ Main page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€



export default function SearchPage() {



  const [searchParams, setSearchParams] = useSearchParams();



  const { results, meta, loading, error, search, hasResults } = useSearch();



  const [showSuta,   setShowSuta]  = useState(false);



  const [searchMode, setSearchMode] = useState('semantic');



  const [kwResults,  setKwResults]  = useState([]);



  const [kwLoading,  setKwLoading]  = useState(false);



  const [, setKwError]            = useState(null);



  const [kwCursor,   setKwCursor]   = useState(null);



  const [kwHasMore,  setKwHasMore]  = useState(false);







  useEffect(() => {



    const query    = searchParams.get('query');



    const language = searchParams.get('language') || 'auto';



    if (query) {



      search({ query, language });



      setShowSuta(false); // reset oracle when query changes



    }



  }, [searchParams]); // eslint-disable-line







  function handleSearch({ query, language }) {



    setSearchParams({ query, language });



  }







  async function handleKeywordSearch(q, reset = true) {



    if (!q?.trim()) return;



    if (reset) { setKwResults([]); setKwCursor(null); }



    setKwLoading(true); setKwError(null);



    try {



      const r = await ApiService.keywordSearch(q, null, 20, reset ? null : kwCursor);



      setKwResults(prev => reset ? r.results : [...prev, ...r.results]);



      setKwCursor(r.cursor || null);



      setKwHasMore(r.has_more);



    } catch (e) { setKwError(e.message); }



    finally { setKwLoading(false); }



  }







  function handleModeSearch(params) {



    if (searchMode === 'word') handleKeywordSearch(params.query, true);



    else handleSearch(params);



  }







  const currentQuery = searchParams.get('query') || '';







  return (



    <div className={styles.page}>



      <SearchBar onSearch={handleModeSearch} loading={loading || kwLoading} initialQuery={currentQuery} />



      <div className={styles.modeRow}>



        <button className={searchMode === 'semantic' ? styles.modeBtnOn : styles.modeBtn} onClick={() => { setSearchMode('semantic'); setKwResults([]); }}>Semantic</button>



        <button className={searchMode === 'word' ? styles.modeBtnOn : styles.modeBtn} onClick={() => setSearchMode('word')}>Word</button>



        {searchMode === 'word' && <span className={styles.modeHint}>Devanagari · IAST · Telugu · English</span>}



      </div>







      {/* â”€â”€ Loading â”€â”€ */}



      {loading && (



        <div className={styles.state}>



          <span className={styles.loadingDots}>⟳</span>



          <span>Searching…</span>



        </div>



      )}







      {/* â”€â”€ Error â”€â”€ */}



      {error && !loading && (



        <div className={styles.state}>



          <span className={styles.errorIcon}>âœ•</span>



          <span>{error}</span>



        </div>



      )}







      {/* â”€â”€ Results header + सूत उवाच button â”€â”€ */}



      {meta && !loading && (



        <div className={styles.resultsHeader}>



          <div className={styles.metaRow}>



            <span>{meta.total_results} results{meta.cached && (
            <span className={styles.cacheIndicator} title={`From sacred memory · matched "${meta.cache_original_query}" · similarity ${(meta.cache_similarity*100).toFixed(0)}%`}>
              ॰
            </span>
          )}</span>



            <span className={styles.metaDot}>·</span>



            <span>{meta.latency_ms}ms</span>



            <span className={styles.metaDot}>·</span>



            <span className={styles.metaLang}>{meta.detected_language}</span>



          </div>



          {hasResults && (



            <button



              className={`${styles.sutaBtn} ${showSuta ? styles.sutaBtnActive : ''}`}



              onClick={() => setShowSuta(s => !s)}



              title="Ask Sūta Gosvāmī to synthesize the tradition's answer"



            >



              <span className={styles.sutaBtnDeva}>सूत उवाच</span>



              {showSuta ? 'â–²' : 'â–¼'}



            </button>



          )}



        </div>



      )}







      {/* â”€â”€ Oracle panel â”€â”€ */}



      {showSuta && currentQuery && (



        <SutaPanel query={currentQuery} onClose={() => setShowSuta(false)} />



      )}







      {/* â”€â”€ Verse results â”€â”€ */}



      {hasResults && !loading && (



        <div className={styles.results} role="list">



          {results.map(verse => (



            <div key={verse.verse_id} role="listitem">



              <VerseCard verse={verse} />



            </div>



          ))}



        </div>



      )}







      {/* Word results */}



      {searchMode === 'word' && (kwResults.length > 0 || kwLoading) && (



        <div className={styles.results}>



          <div className={styles.metaRow}><span>{kwResults.length} matches{kwHasMore ? ' · more available' : ''}</span></div>



          {kwResults.map(v => <div key={v.verse_id}><VerseCard verse={v} /></div>)}



          {kwLoading && <div className={styles.state}><span>Searching…</span></div>}



          {kwHasMore && !kwLoading && <button className={styles.loadMoreBtn} onClick={() => handleKeywordSearch(currentQuery, false)}>Load more</button>}



        </div>



      )}



      {searchMode === 'word' && !kwLoading && kwResults.length === 0 && currentQuery && (



        <div className={styles.state}><span>No matches. Try IAST (atman), Devanagari (†¤à¥®¨à¥), or English.</span></div>



      )}







      {/* â”€â”€ Empty â”€â”€ */}



      {!hasResults && !loading && !error && currentQuery && (



        <div className={styles.state}>



          <span className={styles.emptyIcon}>â—Œ</span>



          <span>No results found</span>



          <span className={styles.emptyHint}>Try a different query or language</span>



        </div>



      )}







      {/* â”€â”€ Prompt â”€â”€ */}



      {!currentQuery && !loading && (



        <div className={styles.state}>



          <span className={styles.promptDeva}>॰</span>



          <span>Search for a verse, concept, or phrase</span>



        </div>



      )}



    </div>



  );



}







